var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-wrapper"},[_vm._m(0),_c('h2',{staticClass:"loadingstatus"},[_vm._v(" "+_vm._s(_vm.loadingstatus)+" ")]),_c('p',{staticClass:"loadingmessage"},[_vm._v(" "+_vm._s(_vm.loadingmessage)+" ")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner"},[_c('div',{staticClass:"bounce1"}),_c('div',{staticClass:"bounce2"}),_c('div',{staticClass:"bounce3"})])
}]

export { render, staticRenderFns }